import React, { useState } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { IconWithText,WarningMessageModal, Tabs, MobileStrip, MobileItemList } from 'Components';
import history from 'src/history';
import './SuppliesMobile.css';

const SuppliesMobile = (props) => {
  const mobileKeys = {
    fixedkeys: [...(props.data.keys || []).slice(0, 2), 'Shipped', 'StatusName'],
    bodyKeys: ['OrderNumber', 'Placed', 'Shipped', 'ProjectNumber', 'CreatedBy', 'Waybill'],
    uniqueKey: 'OrderNumber',
    code: 'order',
  };

  const [section, setSectionName] = useState('');
  const [isWarningMessageOpen, setOpenWarningMessage] = useState(false);

  const handleProceed=() => {
      history.push('/supplies/new');
     setOpenWarningMessage(false);
  }
  const handleCancle = ()=> {
    setOpenWarningMessage(false);
  }
  const handlOnClick = () => {
    if (props.isPrepaid) {
      props.setAppState({ isPrepaidOrder: true });
      history.push('/submissions/new');
    } else {
      if (props.isSupplyWarningON === 'ON') {
        setSectionName('Supply')
        setOpenWarningMessage(true);
      } else {
        history.push('/supplies/new');
      }
    }
  }
 

  return (
    <div className="supplies-mobile">
      <MobileStrip
        title={i18n.t('head:Supplies')}
        left="/jobs"
        right="/invoices"
      />
      <div className="supplies-mobile__new-order">
        <IconWithText
          onClick={handlOnClick}
          icon="add_circle"
          text={i18n.t('orders:NewOrder')}
          textOrientation="before"
        />
      </div>
      <div className="supplies-mobile__tabs">
        <Tabs
          tabs={props.tabs.map(tab => i18n.t(`orders:${tab}`))}
          index={props.data.tabIndex}
          onClick={i => props.handleTabClick(i)}
        />
      </div>
      <MobileItemList
        hasPinned
        mobileKeys={mobileKeys}
        setPageState={props.setPageState}
        data={props.data}
        powerTableIndex={props.powerTableIndex}
        onOptionClick={props.onOptionClick}
        onPinClick={props.onPinClick}
        keyPairs={props.data.keyPairs}
        isPrepaid={props.isPrepaid}
        noInfoTitleText={i18n.t('orders:NoOrders')}
        noInfoSubText={i18n.t('orders:NewOrder1')}
        noInfoLinkText={i18n.t('orders:NewOrder2')}
        noInfoLink="/supplies/new"
        isSupplyWarningON={props.isSupplyWarningON}
        isTemplateWarningON={props.isTemplateWarningON}
        isSubmissionWarningON={props.isSubmissionWarningON}
      />
      <div>
        { isWarningMessageOpen &&
        <WarningMessageModal
          onProceed={handleProceed}
          onCancel={handleCancle}
          section={section}
        />
        }
      </div>
    </div>
  );
};

SuppliesMobile.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.string),
  data: PropTypes.shape({
    keyPairs: PropTypes.shape({}),
    tabIndex: PropTypes.number,
    keys: PropTypes.arrayOf(PropTypes.string),
  }),
  powerTableIndex: PropTypes.number,
  setPageState: PropTypes.func,
  handleTabClick: PropTypes.func,
  onOptionClick: PropTypes.func,
  onPinClick: PropTypes.func,
  isSupplyWarningON: PropTypes.bool,
  isTemplateWarningON: PropTypes.bool,
  isSubmissionWarningON: PropTypes.bool,
  isPrepaid: PropTypes.bool,
};
export default SuppliesMobile;



// WEBPACK FOOTER //
// ./src/containers/Supplies/SuppliesMobile/SuppliesMobile.jsx